import { Injectable } from '@angular/core';
import { HttpClientCustom } from '../custom/http-client';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

@Injectable()
export class AgentsProvider {

  constructor(
    private httpClient: HttpClientCustom,
    private storage: TidyStorage
  ) {}

  async getAgentSettings() {
    const agentSettings = await this.storage.retrieve('agentSettings');
    if (agentSettings) {
      return agentSettings;
    }
    const response = await this.httpClient.get(`api/v1/customer/ai-agents`);
    await this.storage.save('agentSettings', response);
    return response;
  }

  updateAgentSettings(key: string, payload: any) {
    return this.httpClient.post(`api/v1/customer/ai-agents/${key}/set-user-settings`, payload);
  }

  getAgentActivity(key: string, page: number, perPage: number) {
    return this.httpClient.get(`api/v1/customer/ai-agents/${key}/activities?page=${page}&per_page=${perPage}`);
  }

  async clearAgentSettingsCache() {
    await this.storage.save('agentSettings', null);
  }

}
